import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiArrowLeft, FiInfo, FiTrendingUp, FiCheckCircle } = FiIcons;

const features = [
  'Conversion brut ↔ net en temps réel',
  'Calcul selon votre statut (Non-cadre, Cadre, Fonctionnaire, Portage)',
  'Prise en charge du temps partiel',
  'Prélèvement à la source paramétrable',
  'Affichage horaire, mensuel et annuel',
  'Données mises à jour pour 2026',
];

export default function APropos() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-indigo-600 transition-colors mb-8">
        <SafeIcon icon={FiArrowLeft} />
        Retour au calculateur
      </Link>

      <div className="flex items-center gap-3 mb-8">
        <div className="w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center">
          <SafeIcon icon={FiInfo} className="text-indigo-600 text-lg" />
        </div>
        <h1 className="text-3xl font-extrabold text-slate-900">À Propos</h1>
      </div>

      <div className="space-y-6">
        <div className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <SafeIcon icon={FiTrendingUp} className="text-indigo-500" />
            <h2 className="text-lg font-bold text-slate-800">Qu'est-ce que salaire-smic.com ?</h2>
          </div>
          <p className="text-slate-600 text-sm leading-relaxed mb-4">
            <strong>salaire-smic.com</strong> est un calculateur de salaire brut-net gratuit, conçu pour aider les salariés, les candidats à l'embauche et les professionnels des ressources humaines à estimer rapidement leur rémunération nette à partir d'un salaire brut, ou inversement.
          </p>
          <p className="text-slate-600 text-sm leading-relaxed">
            Que vous négociiez une offre d'emploi, prépariez votre budget mensuel ou compariez différents statuts professionnels, cet outil vous donne une estimation claire et immédiate, sans inscription ni collecte de données.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-4">Ce que vous pouvez faire avec cet outil</h2>
          <ul className="space-y-2.5">
            {features.map((f, i) => (
              <li key={i} className="flex items-center gap-3 text-sm text-slate-600">
                <SafeIcon icon={FiCheckCircle} className="text-emerald-500 flex-shrink-0" />
                {f}
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-indigo-50 rounded-2xl p-6 ring-1 ring-indigo-100">
          <h2 className="text-lg font-bold text-slate-800 mb-3">⚠️ Avertissement</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            Les résultats affichés sont des estimations basées sur les taux de cotisations sociales en vigueur en France en 2026. Ils ne tiennent pas compte de toutes les particularités individuelles (conventions collectives, avantages en nature, etc.). Pour une simulation précise, consultez un expert-comptable ou votre service RH.
          </p>
        </div>
      </div>
    </div>
  );
}